import { render, staticRenderFns } from "./BannerConfigTabs.vue?vue&type=template&id=5c4339c1&scoped=true"
import script from "./BannerConfigTabs.vue?vue&type=script&lang=js"
export * from "./BannerConfigTabs.vue?vue&type=script&lang=js"
import style0 from "./BannerConfigTabs.vue?vue&type=style&index=0&id=5c4339c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4339c1",
  null
  
)

export default component.exports